import Image from 'next/image'
import React from 'react'

import clsx from 'clsx'
import { UseFormReturn } from 'react-hook-form'

import { DeviceOrderData } from '@/lib/schemes'
import { Device, OrderEstimate } from '@/lib/types'

import { DevicePerformance } from '@/components/DevicePerformance'

import { OrderAmountBlock } from './OrderAmountBlock'

export const DeviceOrderCard = ({
  form,
  device,
  estimate,
  isLoading,
  isDialogCard,
  isInstallment
}: {
  estimate: OrderEstimate | undefined
  isLoading: boolean
  device: Device
  isInstallment?: boolean
  isDialogCard?: boolean
  form: UseFormReturn<DeviceOrderData>
}) => {
  const { miner } = device

  return (
    <div
      className={clsx(
        'relative flex w-full flex-col rounded-xl border',
        'border-slate-300 p-4 pb-5 tablet:p-4',
        isDialogCard ? 'gap-2' : 'gap-5'
      )}
    >
      <div className="flex gap-4 tablet:gap-6">
        <div className="flex flex-none flex-col items-center tablet:mb-0">
          <div
            className={clsx(
              isDialogCard ? 'h-[62px] w-[60px]' : 'h-[107px] w-[106px]',
              'overflow-hidden rounded-x-xl'
            )}
          >
            <Image
              className="block h-full w-auto max-w-full object-contain"
              alt="Shop card"
              height={isDialogCard ? 60 : 106}
              priority
              src={miner.cover.thumbURL}
              width={isDialogCard ? 62 : 107}
            />
          </div>
        </div>
        <div className="flex flex-auto flex-col">
          <DevicePerformance
            className="desktop:w-full"
            device={device}
            isDialogCard={isDialogCard}
          />
        </div>
      </div>
      <OrderAmountBlock
        {...{
          device,
          form,
          isInstallment,
          estimate,
          isLoading
        }}
      />
    </div>
  )
}
